import loadGoogleMapsApi from 'load-google-maps-api'
import SearchSuggestion from './SearchSuggestion'
import MapTable from './MapTable'
import { $, $1, each, debounce, getParams } from '../util'

function offsetCenter(latlng, offsetx, offsety, map) {

  var scale = Math.pow(2, map.getZoom());

  var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
  var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

  var worldCoordinateNewCenter = new google.maps.Point(
      worldCoordinateCenter.x - pixelOffset.x,
      worldCoordinateCenter.y + pixelOffset.y
  );

  var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

  map.panTo(newCenter);

}

/**
 * @module MapLocator
 * Works with a pointers array with objects:
 * - lat
 * - lng
 * - name
 * - typology
 * - image
 * - city
 * - address
 */
const MapLocator = (() => {
  let googleMapsApi = null
  let googleMapsApiKey = null
  let pointers = null
  let map = null

  let filtersSelectors = []
  let searchSelector = null
  let searchFormSelector = null
  let searchRemoveSelector = null

  let currentFilter = null
  let currentSearch = null

  const syncMapTableSearch = (search) => {
    const mapTableSearch = document.querySelector('.js-map-table-search')
    const mapTableForm = document.querySelector('.js-map-table-form')
    if (!mapTableSearch || !mapTableForm) return

    mapTableSearch.value = search
    mapTableForm.querySelector('.c-button[type="submit"]').click()
  }

  const getFilterPointers = () => {
    if (!currentFilter || currentFilter == '') return pointers
    return pointers.filter ((p) => p.typology == currentFilter || (p.typology == 'gym_rehab' && (currentFilter == 'gym' || currentFilter == 'rehab')))
  }

  const getSearchPointers = () => {
    if (!currentSearch || currentSearch == '') return pointers
    return pointers.filter((p) => p.city.toUpperCase().includes(currentSearch.toUpperCase()))
  }

  const getPointers = () => {
    let a1 = getFilterPointers()
    let a2 = getSearchPointers()
    let final = []

    for (let x = 0; x < a2.length; x++) {
      let found = false

      for (let y = 0; y < a1.length; y++) {
        if (a2[x].lat == a1[y].lat && a2[x].lng == a1[y].lng) {
          found = true
          break
        }
      }

      if (found) final.push(a2[x])
    }

    return final
  }

  const updateCurrentFilter = (filter) => {
    currentFilter = filter

    each(filtersSelectors, (_i, f) => {
      if (f.getAttribute('data-filter') == filter) {
        f.classList.add('is-active')
      } else {
        f.classList.remove('is-active')
      }
    })
  }

  const updateCurrentSearch = (search) => {
    currentSearch = search
    searchSelector.value = search

    syncMapTableSearch(search)
  }

  /**
   * @function renderList
   */
  const renderList = () => {
    MapTable.updateTable(currentFilter)
  }

  /**
   * @function generatePointerTemplate
   */
  const generatePointerTemplate = (pointer) => {
    let cta = `<div class="c-button c-button--main c-map-locator__marker-button" onclick="window.requestMapPopupData('${pointer.typology} ${pointer.uuid}')">Info</div>`
    if (pointer.typology == 'event') {
      cta = `<a href="${pointer.link}" class="c-button c-button--main c-map-locator__marker-button">Info</a>`
    }

    const template = `
    <div class="c-map-locator__marker">
      <div class="c-map-locator__marker-clearfix">
        ${pointer.image ? (
          `
          <div class="c-map-locator__marker-image">
            <div class="c-map-locator__marker-image-img" style="background-image: url(${pointer.image})"></div>
          </div>
          `
        ) : ''}
        <div class="c-map-locator__marker-content">
          <div class="c-map-locator__marker-title">${pointer.name}</div>

          <div class="c-map-locator__marker-info">
            ${pointer.city}
          </div>
        </div>
      </div>
      <div class="c-map-locator__marker-cta">
        ${pointer.phone ? (
          `Tel: ${pointer.phone}<br>`
        ) : ''}
        ${pointer.email ? (
          `Email: ${pointer.email}<br>`
        ) : ''}
        ${pointer.website ? (
          `Website: ${pointer.website}<br>`
        ) : ''}
        ${cta}
      </div>
    </div>`

    return template
  }

  /**
   * @function renderMap
   */
  const renderMap = () => {
    const renderPointers = getPointers()

    const m = new googleMapsApi.Map(map, { mapTypeId: googleMapsApi.MapTypeId.ROADMAP, disableDefaultUI: true })
    const b = new googleMapsApi.LatLngBounds()
    const i = new googleMapsApi.InfoWindow()

    m.setTilt(45)
    each(renderPointers, (_i, pointer) => {
      const position = new googleMapsApi.LatLng(pointer.lat, pointer.lng)
      b.extend(position)

      const marker = new googleMapsApi.Marker({
        map: m,
        position: position,
        title: position.name,
        template: generatePointerTemplate(pointer)
      })

      googleMapsApi.event.addListener(marker, 'click', (function (marker) {
        return function () {
          i.setContent(marker.template)
          offsetCenter(marker.getPosition(), 0, -150, m)
          i.open(m, marker)
        }
      })(marker))

      m.fitBounds(b)
    })

    let boundsListener = googleMapsApi.event.addListener((m), 'bounds_changed', function (_e) {
      // this.setZoom(3)
      googleMapsApi.event.removeListener(boundsListener)
    })
  }
  
  /**
   * @function initializeMap
   */
  const initializeMap = () => {
    loadGoogleMapsApi({ key: googleMapsApiKey })
    .then((googleMaps) => {
      googleMapsApi = googleMaps
      renderMap()
      MapTable.init(currentFilter)
    })
    .catch((err) => console.log(err))
  }

  /**
   * @function listenFilters
   */
  const listenFilters = () => {
    each(filtersSelectors, (_i, filter) => {
      filter.addEventListener('click', (e) => {
        e.preventDefault()

        const filterValue = filter.getAttribute('data-filter')

        if (filterValue !== currentFilter) {
          updateCurrentFilter(filterValue)
          renderMap()
          renderList()
        }
      })
    })
  }

  /**
   * @function listenSearch
   */
  const listenSearch = () => {
    searchSelector.addEventListener('keyup', debounce(() => {
      if (searchSelector.value.length < 1) {
        SearchSuggestion.hideAll()
      }
 
      updateCurrentSearch(searchSelector.value)
      let results = getSearchPointers()

      if (!results || results.length < 1) {
        SearchSuggestion.hideAll()
      }

      results = results.filter((r) => r.typology !== 'event')
      results = results.map((r) => ({ label: r.city, value: r.city }))
      SearchSuggestion.show(searchSelector, results, (result) => {
        updateCurrentSearch(result.value)
        renderMap()
        SearchSuggestion.hideAll()
      })
    }, 250))

    searchFormSelector.addEventListener('submit', (e) => {
      e.preventDefault()
      updateCurrentSearch(searchSelector.value)
      renderMap()
      SearchSuggestion.hideAll()
    })

    searchRemoveSelector.addEventListener('click', (e) => {
      updateCurrentSearch('')
      renderMap()
      SearchSuggestion.hideAll()
    })
  }

  /**
   * @function init
   */
  const init = () => {
    map = $1('.js-map-locator')
    if (!map) return

    googleMapsApiKey = $1('meta[name="google_maps_api_key"]').getAttribute('content')
    pointers = JSON.parse($1('.js-map-locator-pointers').getAttribute('data-pointers'))

    filtersSelectors = $('.js-map-locator-filter')
    searchSelector = $1('.js-map-locator-search')
    searchFormSelector = $1('.js-map-locator-search-form')
    searchRemoveSelector = $1('.js-map-locator-search-remove')

    const params = getParams(window.location.href)
    if (params.filter) updateCurrentFilter(params.filter)
    if (params.search) updateCurrentSearch(params.search)

    initializeMap()
    listenFilters()
    listenSearch()
  }

  return {
    init,
  }
})()

export default MapLocator



// WEBPACK FOOTER //
// app/javascript/scripts/components/MapLocator.js